import BaseEntityModel from "./../../../general/BaseEntityModel";
import defaultImg from "@/assets/images/userWalletTransactions.svg";
import UserInfoData from "./../../../users/UserInfoData";

export default class UserWalletTransaction extends BaseEntityModel {
  icon = defaultImg;
  defaultImg = defaultImg;
  constructor() {
    super();
    this.setInitialValue();
  }
  setInitialValue() {
    this.setInitialValueBaseEntityModel();
    this.mediaFile = "";
    this.userWalletTransactionToken = "";
    this.userWalletTransactionValue = "";
    this.userWalletTransactionValueWithCurreny = "";
    this.userWalletTransactionValueText = "";
    this.userWalletTransactionTypeToken = "";
    this.userWalletTransactionTypeNameCurrent = "";
    this.userWalletTransactionMethodToken = "";
    this.userWalletTransactionMethodNameCurrent = "";
    this.userWalletTransactionImageIsDefault = "";
    this.userWalletTransactionImagePath = "";
    this.userWalletTransactionImageSizeBytes = "";
    this.userWalletTransactionImageSizeTextCurrent = "";
    this.userWalletTransactionNotes = "";
    this.userToken = "";
    this.userInfoData = new UserInfoData();
  }
  fillData(data) {
    if (data) {
      this.fillDataBaseEntityModel(data);
      this.mediaFile = "";
      this.userWalletTransactionToken = data.userWalletTransactionToken ?? "";
      this.userWalletTransactionValue = data.userWalletTransactionValue ?? "";
      this.userWalletTransactionValueWithCurreny =
        data.userWalletTransactionValueWithCurreny ?? "";
      this.userWalletTransactionValueText =
        data.userWalletTransactionValueText ?? "";
      this.userWalletTransactionTypeToken =
        data.userWalletTransactionTypeToken ?? "";
      this.userWalletTransactionTypeNameCurrent =
        data.userWalletTransactionTypeNameCurrent ?? "";
      this.userWalletTransactionMethodToken =
        data.userWalletTransactionMethodToken ?? "";
      this.userWalletTransactionMethodNameCurrent =
        data.userWalletTransactionMethodNameCurrent ?? "";
      this.userWalletTransactionImageIsDefault =
        data.userWalletTransactionImageIsDefault ?? "";
      this.userWalletTransactionImagePath =
        data.userWalletTransactionImagePath ?? "";
      this.userWalletTransactionImageSizeBytes =
        data.userWalletTransactionImageSizeBytes ?? "";
      this.userWalletTransactionImageSizeTextCurrent =
        data.userWalletTransactionImageSizeTextCurrent ?? "";
      this.userWalletTransactionNotes = data.userWalletTransactionNotes ?? "";
      this.userToken = data.userToken ?? "";
      this.userInfoData.fillData(data.userInfoData);
    } else {
      this.setInitialValue();
    }
  }
}
